import { createRouter } from "@tanstack/react-router";
import { stringifySearch } from "./utils/search-params";
import { stopActiveStream } from "./components/sign/ConsentSign";
import { reportFrontendError } from "./lib/error-reporter";
import { ErrorFallback } from "./components/error-fallback";
import { Route as rootRoute } from "./routes/__root";
import { Route as indexRoute } from "./routes/index";
import { Route as patientRoute } from "./routes/id-me";
import { Route as signRoute } from "./routes/sign";
import { Route as consentRoute } from "./routes/consent";
import { Route as connectedRoute } from "./routes/connected";
import { Route as linkExpiredRoute } from "./routes/link-expired";
import { Route as deleteYourDataRoute } from "./routes/delete-your-data";
import { Route as inviteRoute } from "./routes/invite";
import { Route as syntheticHospitalLoginRoute } from "./routes/synthetic-hospital-login";
import { Route as dashboardLayout } from "./routes/dashboard/_layout";
import { Route as patientsRoute } from "./routes/dashboard/patients";
import {
  Route as patientLayoutRoute,
  IndexRoute as patientIndexRoute,
} from "./routes/dashboard/patient-layout";
import { Route as patientSummaryRoute } from "./routes/dashboard/patient-summary";
import {
  Route as patientOnboardingRoute,
  TabRoute as patientOnboardingTabRoute,
} from "./routes/dashboard/patient-onboarding";
import { Route as patientConnectionsRoute } from "./routes/dashboard/patient-connections";
import { Route as patientConnectionDetailRoute } from "./routes/dashboard/patient-connection-detail";
import { Route as settingsRoute } from "./routes/dashboard/settings";
const routeTree = rootRoute.addChildren([
  indexRoute,
  patientRoute,
  signRoute,
  consentRoute,
  connectedRoute,
  linkExpiredRoute,
  deleteYourDataRoute,
  inviteRoute,
  syntheticHospitalLoginRoute,
  dashboardLayout.addChildren([
    patientsRoute,
    patientLayoutRoute.addChildren([
      patientIndexRoute,
      patientSummaryRoute,
      patientOnboardingRoute,
      patientOnboardingTabRoute,
      patientConnectionsRoute,
      patientConnectionDetailRoute,
    ]),
    settingsRoute,
  ]),
]);

export const router = createRouter({
  routeTree,
  stringifySearch,
  defaultErrorComponent: ErrorFallback,
  defaultOnCatch: (error) =>
    reportFrontendError({ message: error.message, stack: error.stack ?? "" }),
});

// Stop the camera stream whenever navigating away from /sign.
router.history.subscribe(({ location }) => {
  if (!location.pathname.startsWith("/sign")) {
    stopActiveStream();
  }
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
